var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-carousel',{attrs:{"autoplay":"","dots":false,"effect":"fade"}},[_c('a',{attrs:{"target":"_blank","href":"https://forms.gle/7hJrJUhAHkdTjod89"}},[_c('img',{attrs:{"src":"/resources/images/banner/feriados_carnavanal.png"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }